import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Catalogo, General } from '../../interfaces/general';


@Component({
  selector: 'app-datos-escolares-laborales',
  templateUrl: './datos-escolares-laborales.component.html',
  styleUrls: ['./datos-escolares-laborales.component.css']
})
export class DatosEscolaresLaboralesComponent implements OnInit {
	@Input() DatosEscolaresLaborales: FormGroup;
	@Input() catalogos:General

  constructor() {}

	ngOnInit(): void {}

}
